import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCloneSectionRequest = {};
var _bulkCloneSectionResponse = {};
var _bulkCreateSectionMigrationRequest = { sections: '_section' };
var _bulkCreateSectionMigrationResponse = { results: '_bulkSectionResult' };
var _bulkCreateSectionRequest = { sections: '_section' };
var _bulkCreateSectionResponse = { results: '_bulkSectionResult' };
var _bulkSectionResult = { item: '_section' };
var _cloneSectionRequest = {};
var _cloneSectionResponse = { section: '_section' };
var _createSectionRequest = { section: '_section' };
var _createSectionResponse = { section: '_section' };
var _deleteAllProgramSectionsRequest = {};
var _deleteAllProgramSectionsResponse = {};
var _deleteSectionRequest = {};
var _deleteSectionResponse = {};
var _description = { image: '_image', video: '_videoV2' };
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getSectionRequest = {};
var _getSectionResponse = { section: '_section' };
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _listSectionsRequest = {};
var _listSectionsResponse = { sections: '_section' };
var _moveSectionRequest = {};
var _moveSectionResponse = { section: '_section' };
var _publishSectionRequest = {};
var _publishSectionResponse = { section: '_section' };
var _querySectionsRequest = {};
var _querySectionsResponse = { sections: '_section' };
var _restoreSectionFromTrashRequest = {};
var _restoreSectionFromTrashResponse = { section: '_section' };
var _section = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    ordering: 'DOUBLE',
    description: '_description',
};
var _updateSectionRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    section: '_section',
};
var _updateSectionResponse = { section: '_section' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
function resolveWixOnlineprogramsSectionsV3SectionsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/program-sections-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/program-sections-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/program-sections-service',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/program-sections-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/program-sections-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/program-sections-service',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/program-sections-service',
                destPath: '',
            },
            {
                srcPath: '/program-sections-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/program-sections-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/program-sections-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/program-sections-service',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/program-sections-service',
                destPath: '',
            },
            {
                srcPath: '/program-sections-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/program-sections-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/program-sections-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a Section. */
export function createSection(payload) {
    var _a = serializer(_createSectionRequest, { _description: _description, _focalPoint: _focalPoint, _image: _image, _section: _section, _videoResolution: _videoResolution, _videoV2: _videoV2 }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSectionResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _section: _section,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __createSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.CreateSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/sections',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSection.fromReq = fromReq;
    __createSection.__isAmbassador = true;
    return __createSection;
}
/** Bulk Section creation. */
export function bulkCreateSection(payload) {
    var _a = serializer(_bulkCreateSectionRequest, { _description: _description, _focalPoint: _focalPoint, _image: _image, _section: _section, _videoResolution: _videoResolution, _videoV2: _videoV2 }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateSectionResponse, {
        _bulkSectionResult: _bulkSectionResult,
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _section: _section,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkCreateSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.BulkCreateSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/bulk/sections/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateSection.fromReq = fromReq;
    __bulkCreateSection.__isAmbassador = true;
    return __bulkCreateSection;
}
/** Bulk Section creation for migration. */
export function bulkCreateSectionMigration(payload) {
    var _a = serializer(_bulkCreateSectionMigrationRequest, { _description: _description, _focalPoint: _focalPoint, _image: _image, _section: _section, _videoResolution: _videoResolution, _videoV2: _videoV2 }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateSectionMigrationResponse, {
        _bulkSectionResult: _bulkSectionResult,
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _section: _section,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkCreateSectionMigration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.BulkCreateSectionMigration',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/bulk/sections/create/migration',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateSectionMigration.fromReq = fromReq;
    __bulkCreateSectionMigration.__isAmbassador = true;
    return __bulkCreateSectionMigration;
}
/** Retrieves a Section. */
export function getSection(payload) {
    var _a = serializer(_getSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSectionResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _section: _section,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.GetSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/sections/{sectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSection.fromReq = fromReq;
    __getSection.__isAmbassador = true;
    return __getSection;
}
/** Updates a Section. */
export function updateSection(payload) {
    var _a = serializer(_updateSectionRequest, { _description: _description, _focalPoint: _focalPoint, _image: _image, _section: _section, _videoResolution: _videoResolution, _videoV2: _videoV2 }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSectionResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _section: _section,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'PATCH',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.UpdateSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/sections/{section.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSection.fromReq = fromReq;
    __updateSection.__isAmbassador = true;
    return __updateSection;
}
/**
 * Deletes a Section.
 * Deleting a Section permanently removes them from the Section List.
 */
export function deleteSection(payload) {
    var _a = serializer(_deleteSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSectionResponse, {}).fromJSON;
    function __deleteSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'DELETE',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.DeleteSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/sections/{sectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSection.fromReq = fromReq;
    __deleteSection.__isAmbassador = true;
    return __deleteSection;
}
/** Delete all program sections */
export function deleteAllProgramSections(payload) {
    var _a = serializer(_deleteAllProgramSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteAllProgramSectionsResponse, {}).fromJSON;
    function __deleteAllProgramSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.DeleteAllProgramSections',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/sections/delete/all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteAllProgramSections.fromReq = fromReq;
    __deleteAllProgramSections.__isAmbassador = true;
    return __deleteAllProgramSections;
}
/**
 * Retrieves a list of Sections, given the provided [paging, filtering, and sorting][1].
 *
 * Up to 1,000 Sections can be returned per request.
 */
export function querySections(payload) {
    var _a = serializer(_querySectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_querySectionsResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _section: _section,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __querySections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.QuerySections',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/sections/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySections.fromReq = fromReq;
    __querySections.__isAmbassador = true;
    return __querySections;
}
/** List sections per program id */
export function listSections(payload) {
    var _a = serializer(_listSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSectionsResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _section: _section,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __listSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.ListSections',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/sections',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSections.fromReq = fromReq;
    __listSections.__isAmbassador = true;
    return __listSections;
}
/** Clones section with specified id */
export function cloneSection(payload) {
    var _a = serializer(_cloneSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneSectionResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _section: _section,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __cloneSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.CloneSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/sections/{sectionId}/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneSection.fromReq = fromReq;
    __cloneSection.__isAmbassador = true;
    return __cloneSection;
}
/** Places section after specified one or inserts it in the beginning */
export function moveSection(payload) {
    var _a = serializer(_moveSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_moveSectionResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _section: _section,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __moveSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'PATCH',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.MoveSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/sections/move',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __moveSection.fromReq = fromReq;
    __moveSection.__isAmbassador = true;
    return __moveSection;
}
/** Publishes section */
export function publishSection(payload) {
    var _a = serializer(_publishSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_publishSectionResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _section: _section,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __publishSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'PATCH',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.PublishSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/sections/publish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __publishSection.fromReq = fromReq;
    __publishSection.__isAmbassador = true;
    return __publishSection;
}
/** Clones all sections from prototype program */
export function bulkCloneSection(payload) {
    var _a = serializer(_bulkCloneSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCloneSectionResponse, {}).fromJSON;
    function __bulkCloneSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.BulkCloneSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/bulk/sections/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCloneSection.fromReq = fromReq;
    __bulkCloneSection.__isAmbassador = true;
    return __bulkCloneSection;
}
/** Restore section from trash bin */
export function restoreSectionFromTrash(payload) {
    var _a = serializer(_restoreSectionFromTrashRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreSectionFromTrashResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _section: _section,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __restoreSectionFromTrash(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.section',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.sections.v3.SectionsService.RestoreSectionFromTrash',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsSectionsV3SectionsServiceUrl({
                protoPath: '/v3/sections/restore',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreSectionFromTrash.fromReq = fromReq;
    __restoreSectionFromTrash.__isAmbassador = true;
    return __restoreSectionFromTrash;
}
//# sourceMappingURL=http.impl.js.map